export function pageTitles(selector) {
  const element = document.querySelector(selector);

  if (!element) {
    return;
  }

  const button = element.querySelector('.dke_pagetitles__title');
  const container = element.querySelector('.dke_pagetitles__container');
  button.addEventListener('click', () => {
    element.classList.toggle('active');
    if (element.classList.contains('active')) {
      const height = container.scrollHeight;
      container.style.minHeight = height + 'px';
    } else {
      container.style.minHeight = '0px';
    }
  });
}
